import DashboardHeader from "./dashboard-header";

export default DashboardHeader;
